import React, { Component } from 'react';
import { Form, Button, Input, Radio } from 'antd';

import { ConfirmationWrapper } from './style';

const { Item } = Form;
const { TextArea } = Input;

class EnterpriseForm extends Component {

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { fiat_system_description, ...rest } = values;
                let formValues = {
                    ...rest,
                }
                if (rest.has_fiat_system) {
                    formValues.fiat_system_description = fiat_system_description;
                }
                this.props.onSubmitEnterprise(formValues);
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <ConfirmationWrapper>
                <div className="fiat-section">
                    <b>Voyager application</b>
                    <div className="warning-text">It is important to complete the form with correct and detailed information to avoid delays.</div>
                    <div className="w-75">After completing the form below a sales representative will email you within 24/48 hours with further instructions of how to proceed.</div>
                </div>
                <Form
                    onSubmit={this.handleSubmit}
                    className="enterprise-form"
                >
                    <div className="form-container">
                        <Item>
                            <h4 className="head">Full name</h4>
                            {getFieldDecorator('name', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: true,
                                        message: 'Required value'
                                    },
                                ],
                            })(
                                <Input placeholder="Write your full name" />
                            )}
                        </Item>
                        <Item>
                            <h4 className="head">Company</h4>
                            {getFieldDecorator('company', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: true,
                                        message: 'Required value'
                                    },
                                ],
                            })(
                                <Input placeholder="Company" />
                            )}
                        </Item>
                        <Item>
                            <h4 className="head">Country</h4>
                            {getFieldDecorator('country', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: true,
                                        message: 'Required value'
                                    },
                                ],
                            })(
                                <Input placeholder="Country" />
                            )}
                        </Item>
                        <Item>
                            <h4 className="head">Website</h4>
                            {getFieldDecorator('website', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: true,
                                        message: 'Required value'
                                    },
                                ],
                            })(
                                <Input placeholder="Website" />
                            )}
                        </Item>
                        <Item>
                            <h4 className="head">Phone</h4>
                            {getFieldDecorator('phone', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: true,
                                        message: 'Required value'
                                    },
                                ]
                            })(
                                <Input placeholder="Phone" />
                            )}
                        </Item>
                        <Item>
                            <h4 className="head">Exchange business Intro</h4>
                            <span className="content-text-small">
                                Short Introduction of your exchange business such as expected user-base, fiat or crypto only and the trading volumes expected.
                            </span>
                            {getFieldDecorator('business_intro', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: true,
                                        message: 'Required value'
                                    },
                                ],
                            })(
                                <TextArea
                                    placeholder="Describe your exchange business idea in detail"
                                    rows={5}
                                />
                            )}
                        </Item>
                        <Item>
                            <h4 className="head">Do you have a tech team?</h4>
                            <span className="content-text-small">
                                Are any of your team members developers or have a background in technology?
                            </span>
                            <div>
                                {getFieldDecorator('team', {
                                    initialValue: true,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Select an option',
                                        },
                                    ],
                                })(
                                    <Radio.Group>
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>
                                )}
                            </div>
                        </Item>
                        <Item>
                            <h4 className="head">Fiat systems</h4>
                            <span className="content-text-small">
                                Do you have bank account or other payment fiat methods?
                            </span>
                            <div>
                                {getFieldDecorator('has_fiat_system', {
                                    initialValue: true,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Select an option',
                                        },
                                    ],
                                })(
                                    <Radio.Group>
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>
                                )}
                            </div>
                        </Item>
                        <Item>
                            {getFieldDecorator('fiat_system_description', {
                                initialValue: '',
                                rules: [
                                    {
                                        required: true,
                                        message: 'Required value',
                                    },
                                ],
                            })(
                                <Input placeholder="If yes, provide a brief overview of the fiat systems" />
                            )}
                        </Item>
                        <Item>
                            <h4 className="head">Budget</h4>
                            <span className="content-text-small">
                                What is your funding/budget for running an exchange?
                            </span>
                            <div>
                                {getFieldDecorator('budget', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Select an option',
                                        }
                                    ],
                                })(
                                    <Radio.Group
                                        name="budget"
                                        className="budget-options"
                                    >
                                        <Radio value={'low'}>
                                            Under $9,600
                                        </Radio>
                                        <Radio value={'low-medium'}>
                                            Between $9,600 to $50,000
                                        </Radio>
                                        <Radio value={'medium'}>
                                            Between $50,000 to $250,000
                                        </Radio>
                                        <Radio value={'high'}>
                                            Over $250,000
                                        </Radio>
                                    </Radio.Group>
                                )}
                            </div>
                        </Item>
                    </div>
                    <div className="btn-area">
                        <Button block type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </div>
                </Form>
            </ConfirmationWrapper>
        );
    }
}

export default EnterpriseForm;
